<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">ACKNOWLEDGMENTS</span></p>
<p class="tni">My thanks to <span class="epub-i">People</span> managing editor Landon Y. Jones and chief of reporters Nancy P. Williamson for their patience and support. Also, I owe a debt of gratitude to my editor Charles Spicer and his assistant, Liz Weinstock, St. Martin’s’ managing editor John Rounds, my agent Jane Dystel, and <span class="epub-i">People</span> writer Joe Treen.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?04e637b4